import React from "react";
import CustomGridToolbar from "../GridToolbar";
import StyledDataGrid from "styles/styledDataGrid";

function CollapsibleTable({ columns, rows, rowSlot, hpKey, ...props }) {
  const overlayMessage = hpKey
    ? "No policy history data for selected healthplan"
    : "Select Health Plan to view Policy History data";

  return (
    <>
      <StyledDataGrid
        columns={columns}
        rows={rows}
        rowHeight={40}
        disableColumnSelector={true}
        disableColumnFilter={true}
        slots={{
          toolbar: CustomGridToolbar,
          noRowsOverlay: () => (
            <div
              style={{
                textAlign: "center",
                height: "100%",
                fontSize: "120%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="no-row-overlay"
            >
              {overlayMessage}
            </div>
          ),
          ...(rowSlot ? { row: rowSlot } : {}),
        }}
        slotProps={{
          toolbar: {
            hpKey: hpKey,
            exportComponent: props.exportComponent,
            showQuickFilter: true,
          },
          ...(rowSlot ? { row: { rows, hpKey } } : {}),
        }}
        {...props}
      />
    </>
  );
}

export default CollapsibleTable;
